import moment from "moment/moment";
import {classNames} from "../../util/util-helpers";
import React from "react";
import {formatNumber} from "chart.js/helpers";

export default function DueDateTableCell({item}) {
    let OdometerDue = 0;
    let HoursDue = 0;
    let DateDueIn = null

    if (item.TruckID) {
        const LastOdometerRun = item.LastOdometerRun;
        const NextService = LastOdometerRun + item.OdometerInterval;
        OdometerDue = NextService - item.Mileage;
    }

    if (item.TrailerID) {
        const LastHoursRun = item.LastHoursRun;
        const NextService = LastHoursRun + item.HoursInterval;
        HoursDue = NextService - item.Hours;
    }

    if (item.LastDateRun) {
        const DateDue = moment(item.LastDateRun).add(Number(item.DateInterval) ?? 0, "days")
        DateDueIn = DateDue.diff(moment(), 'days')
    }

    return (
        <div className={"flex flex-col"}>
            {
                !!item.IsByDate && (DateDueIn || DateDueIn === 0) && (
                    <div
                        className="w-full inline-flex items-center justify-between px-2.5 py-1 text-xs font-medium pointer-events-none"
                    >
                            <span
                                className={
                                    classNames(
                                        !item.IsDateDue && !item.IsDateWarning ? "text-green-600" : undefined,
                                        item.IsDateWarning && !item.IsDateDue ? "text-yellow-600" : undefined,
                                        item.IsDateDue ? "text-red-500" : undefined,
                                    )}>
                                {(DateDueIn || DateDueIn === 0) ? formatNumber(DateDueIn, undefined) + " days" : ""}
                            </span>
                    </div>

                )
            }
            {
                !!item.IsByOdometer && !!item.TruckID && (
                    <div
                        className="w-full inline-flex items-center justify-between px-2.5 py-1 text-xs font-medium pointer-events-none"
                    >
                                <span
                                    className={
                                        classNames(
                                            !item.IsOdometerWarning && !item.IsOdometerDue ? "text-green-600" : undefined,
                                            item.IsOdometerWarning && !item.IsOdometerDue ? "text-yellow-600" : undefined,
                                            item.IsOdometerDue ? "text-red-500" : undefined,
                                        )
                                    }
                                >
                                    {(OdometerDue || OdometerDue === 0) ? formatNumber(Math.round(OdometerDue, 0), undefined) + " mil." : ""}
                                </span>
                    </div>
                )
            }
            {
                !!item.IsByHours && !!item.TrailerID && (

                        <div
                            className="w-full inline-flex items-center justify-between px-2.5 py-1 text-xs font-medium pointer-events-none"
                        >
                            <span
                                className={
                                    classNames(
                                        !item.IsHoursDue && !item.IsHoursWarning ? "text-green-600" : undefined,
                                        item.IsHoursDue ? "text-red-500" : undefined,
                                        item.IsHoursWarning && !item.IsHoursDue ? "text-yellow-600" : undefined)}
                            >
                                {(HoursDue || HoursDue === 0) ? HoursDue + " hours" : ""}
                            </span>
                        </div>
                )
            }</div>)
}